import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DropdownNature, NatureDto } from '../interfaces';
import { map, shareReplay } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class NaturesService {
  private iCourrierURL: string;
  private natures$: Observable<NatureDto[]>;

  constructor(private http: HttpClient) {
    const config = environment;
    this.iCourrierURL = config.apiICourrierBaseUrl;
  }

  /**
   * Fetches the natures and caches the result for the app lifetime (it rarely changes during a session).
   */
  public fetchNatures(): Observable<NatureDto[]> {
    if (!this.natures$) {
      this.natures$ = this.http.get<NatureDto[]>(`${this.iCourrierURL}/Global/Natures`).pipe(shareReplay(1));
    }
    return this.natures$;
  }

  public fetchMappedNaturesToPrimeNGDropdowns(): Observable<DropdownNature[]> {
    return this.fetchNatures().pipe(
      map((res: NatureDto[]) => {
        const mappedNaturesArray: DropdownNature[] = [];

        res.forEach((nature: NatureDto) => {
          let mappedNature: DropdownNature = {} as DropdownNature;
          mappedNature = { ...nature, label: nature.description, value: nature.id };
          mappedNaturesArray.push(mappedNature);
        });

        return mappedNaturesArray;
      })
    );
  }
}
